export default {
  shareOfVoiceRecommendations: [],
  shareOfVoiceRecommendation: undefined,
};
